import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { PERSONAS } from "../lib/brand";

function Column({ p, index }) {
  return (
    <motion.div
      data-testid={`persona-${p.no}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ delay: index * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-col border-t border-border p-7 first:border-t-0 md:border-l md:border-t-0 md:first:border-l-0 md:p-9"
    >
      <span className="mb-6 inline-flex w-fit items-center rounded-sm bg-forest px-3 py-1.5 font-mono text-[0.62rem] uppercase tracking-[0.18em] text-cream-100">
        {p.kicker}
      </span>
      <h3 className="font-display text-2xl font-semibold leading-tight text-forest md:text-3xl">
        {p.title}
      </h3>
      <p className="mt-4 text-forest-light">{p.intro}</p>
      <ul className="mt-6 space-y-4">
        {p.points.map((pt, i) => (
          <li key={i} className="flex gap-3">
            <span className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-terracotta" />
            <span className="leading-relaxed text-forest">{pt}</span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
}

export default function WhoWeServe() {
  return (
    <>
      <PageHeader
        overline="Who we serve"
        lines={["An open invitation, whatever", "kind of buyer you are"]}
        intro="From quick-commerce fill rates to container-scale exports—the same commission desk, timed against a wide range of fruit families and two hemispheres of supply."
      />

      <section className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <Reveal>
          <div className="grid overflow-hidden rounded-sm border border-border bg-cream-100 md:grid-cols-3">
            {PERSONAS.map((p, i) => (
              <Column key={p.no} p={p} index={i} />
            ))}
          </div>
        </Reveal>
      </section>

      <section className="border-t border-border">
        <Reveal className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-8 px-5 py-20 md:flex-row md:items-center md:px-10 md:py-28">
          <h2 className="max-w-2xl font-display text-3xl font-medium leading-[1.05] text-forest md:text-5xl">
            What you want to buy
          </h2>
          <Link
            to="/contact"
            data-testid="serve-contact-btn"
            className="group flex flex-none items-center gap-3 rounded-full bg-forest px-7 py-4 text-cream-100 transition-colors duration-300 hover:bg-forest/90"
          >
            <span className="text-cream-100 tracking-wide" style={{ fontSize: "0.8rem" }}>Start an enquiry</span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </section>
    </>
  );
}
